import { Injectable } from '@angular/core';
import { AsyncSubject } from 'rxjs/AsyncSubject';
import { Subject } from 'rxjs/Subject';

import { Task } from '../../objects/task.class';
import { RcsConnectorOdooProvider } from '../rcs-connector-odoo/rcs-connector-odoo';
import { RcsStackDbProvider } from '../rcs-stack-db-service/rcs-stack-db-service';
import { RcsConnectorIndexDbProvider } from '../rcs-connector-index-db/rcs-connector-index-db';
import { ToastController } from 'ionic-angular';

@Injectable()
export class RcsStackProvider{

  //private running_sync_tasks:Array<any> = []
  public async_process_overwatch = new AsyncSubject()
  private task_guardian = new Subject()

  constructor(
    private odoo_service: RcsConnectorOdooProvider,
    private stack_db_service: RcsStackDbProvider,
    private db_service: RcsConnectorIndexDbProvider,
    private toast_control: ToastController){}

  // Fügt einen Task zum Stack hinzu
  public add_task(id:number, method:string, params:Array<any>, module_id: number):void{
    let task = new Task(id, method, params, module_id);
    if(localStorage.getItem("online_status") === 'true'){ // Todo: Change IT!
      this.execute_task(task);
    }else{
      this.stack_db_service.add_tasks_to_stack(task);
    }
  }

  // Tasks werden schematisch abgearbeitet, sobald Internet-Verbindung besteht
  public stack_running():void{
    this.toast_control.create({
      message: 'Offline-Daten werden mit Livesystem synchronisiert',
      duration: 3000,
      position: 'bottom'
    }).present();
    this.stack_db_service.get_tasks().subscribe(
      tasks => {
        if (tasks.length > 0){
          this.execute_task(tasks);
        }
      }
    )
  }

  // Returnt ein Ergebniss wenn alle überwachten Prozesse zurückkamen
  public overwatch_task_processes(id_list:Array<number>){
    let process_guardian = new AsyncSubject();
    let passed_items = 0;

    if (id_list.length > 0){
      this.task_guardian.scan((acc, curr) => Object.assign({}, acc, curr), {}).subscribe(
        response => {
          let task:any = response;
          if (id_list.indexOf(task.id) !== -1){
            passed_items ++;
            process_guardian.next(passed_items);
            if (passed_items == id_list.length){
              process_guardian.complete();
            }
          }
      });
    }else{
      process_guardian.next(true);
      process_guardian.complete();
    }
    return process_guardian;
  }

  // Führt die Bearbeitung und Speicherung der Repeat-Task Resultate aus
  private execute_repeat_task(item){
    setInterval(function(){
      if (this.odoo_service[item.task.method]){
        this.odoo_service[item.task.method].apply(this.odoo_service, item.task.params);
      }
    });
  }

  // Führt die Bearbeitung und Speicherung der Task Resultate aus
  private execute_task(tasks){
    if (this.odoo_service[tasks[0].task.method]){
      if (this.odoo_service[tasks[0].task.method]){
        this.odoo_service[tasks[0].task.method].apply(this.odoo_service, tasks[0].task.params).subscribe(
          response => {
            console.log('ODOO RESPONSE', response.json())
            this.stack_db_service.remove_stack_item(tasks[0].task.module_id);
            this.task_guardian.next(response.json());
            tasks.splice(0, 1);
            if (tasks.length > 0){
              this.execute_task(tasks);
            }
            if (tasks.length == 0){
              this.toast_control.create({
                message: 'Offline-Daten wurden synchronisiert',
                duration: 3000,
                position: 'bottom'
              }).present();
            }
          },
          error => { console.log(error) }
        )
      }
    }
  }

  private finish_job_task(job){
    this.db_service.get_record_by_key('login', 'user_login').subscribe(
      login => {
        this.odoo_service.workflow_manipulations(login, 'rcs.kdienst.auftrag', 'finish_work', job.id).subscribe(
          result => { console.log(result) }
        );
        //this.add_task(1, 'workflow_manipulations', [login, 'rcs.kdienst.auftrag', 'finish_work', job.id], job.id);
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/providers/rcs-stack-service/rcs-stack-service.ts